export class Path {
    private static BASE_PATH: string = './';

    public static registerBasePath(basePath: string): void {
        if (process.env.APP_HOME !== undefined) {
            Path.BASE_PATH = process.env.APP_HOME + '/';
        } else {
            Path.BASE_PATH = basePath + (basePath.endsWith('/') ? '' : '/');
        }
    }

    public static data(): string {
        return Path.BASE_PATH + 'data/';
    }

    public static db(): string {
        return Path.storage() + 'db/';
    }

    public static root(): string {
        return Path.BASE_PATH;
    }

    public static session(): string {
        return Path.storage() + 'session/';
    }

    public static storage(): string {
        return Path.BASE_PATH + 'storage/';
    }
}
